/**
 * CategoryResultList Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { VelocityComponent } from 'velocity-react';
import Heading from '../../../atoms/text/Heading';

export type InstantSearchResultCategory = keyof SafeGraphQLEntityOmit<GQL.IInstantSearchResult, 'id'>;
type ResultItem = GQL.ITrack | GQL.IArtist | GQL.ITaxonomyTerm;

interface IOwnProps<T extends ResultItem> {
  category: InstantSearchResultCategory;
  className: string;
  index: number;
  results: T[] | null;
  title: string;
  children(result: T): React.ReactNode;
}

export class CategoryResultList<T extends ResultItem> extends React.PureComponent<IOwnProps<T>> {
  render() {
    const {
      children,
      className,
      index,
      results,
      title,
    } = this.props;

    const classes = new BEM(className);

    return results && results.length ? (
      <VelocityComponent
        animation="transition.slideUpIn"
        duration={250}
        delay={50 * index}
        runOnMount
      >
        <div {...classes()}>
          <Heading is="h6" {...classes('title')}>{title}</Heading>
          <ul {...classes('list')}>
            {results.map((result) => (
              <li key={result.id} {...classes('list__item')}>
                {children(result)}
              </li>
            ))}
          </ul>
        </div>
      </VelocityComponent>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/InstantSearch/CategoryResultList.tsx